import React from "react";
import { Link } from "react-router-dom";

import { socials } from "../../../databases/socials";
import { SocialMediaIcon } from "../SocialMediaIcon/SocialMediaIcon";

import "./Footer.scss";

export const Footer = () => {
  return (
    <footer className="modern-footer">
      <div className="modern-footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <span className="footer-kicker">FROM MOROCCO TO THE WORLD</span>

            <h2>
              CULTURE DOESN'T
              <span>ASK FOR PERMISSION.</span>
            </h2>
          </div>

          <Link to="/contact" className="footer-contact-btn">
            LET'S CONNECT
            <span>↗</span>
          </Link>
        </div>

        <div className="footer-divider" />

        <div className="footer-middle">
          <div className="footer-column">
            <span className="footer-column-title">EXPLORE</span>

            <Link to="/lembawe9">Lembawe9</Link>
            <Link to="/راب-الشوارع">Street Rap</Link>
            <Link to="/lhangar">LHANGAR</Link>
            <Link to="/artists">Artists</Link>
          </div>

          <div className="footer-column">
            <span className="footer-column-title">DISCOVER</span>

            <Link to="/music">Music</Link>
            <Link to="/gallery">Gallery</Link>
            <Link to="/universe">Universe</Link>
            <Link to="/news">News</Link>
          </div>

          <div className="footer-column">
            <span className="footer-column-title">MORE</span>

            <Link to="/burnitorburnout">Burn It Or Burn Out</Link>
            <Link to="/merch">Merch</Link>
            <Link to="/contact">Contact</Link>
          </div>

          <div className="footer-column footer-socials">
            <span className="footer-column-title">FOLLOW</span>

            <ul>
              {socials.map((social, index) => (
                <li key={index}>
                  <SocialMediaIcon
                    props={{
                      icon: social.icon,
                      link: social.url
                    }}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer-divider" />

        <div className="footer-bottom">
          <p>© 2020–{new Date().getFullYear()} BURN IT OR BURN OUT</p>

          <p>All Rights Reserved</p>

          <p>
            Designed & Developed by{" "}
            <a 
              href="https://www.linkedin.com/in/saad-ouardi/"
              target="_blank" 
              rel="noopener noreferrer"
            >Saad Ouardi</a>
          </p>
        </div>
      </div>
    </footer>
  );
};
